import { createReducer } from 'redux-act';
import { updateFormData, setBookingClientRequestId, setBookingChannel, clearFormData } from './checkoutActions';
import merge from 'lodash/merge';

const initialState = {
  bookingChannel: undefined,
  bookingClientRequestId: undefined,
  formData: {
    title: undefined,
    firstName: undefined,
    lastName: undefined,
    emailAddress: undefined,
    phoneNumber: undefined,
    subscribe: undefined,
    specialRequests: undefined,
    qffNumber: undefined,
    abn: undefined,
    paymentMode: undefined,
    payments: {
      voucher: {
        amount: undefined,
        code: undefined,
      },
      points: {
        amount: undefined,
        amountInCash: undefined,
        tierVersionCode: undefined,
        qffNumber: undefined,
      },
      travelPass: {
        amount: undefined,
      },
      cash: {
        payableNow: {
          amount: undefined,
        },
        payableLater: {
          amount: undefined,
          date: undefined,
        },
        creditCard: {
          sessionId: undefined,
          expiryMonth: undefined,
          expiryYear: undefined,
          cardType: undefined,
          cardNumber: undefined,
          securityCode: undefined,
          apiVersion: undefined,
          merchantId: undefined,
        },
      },
    },
  },
};

export const reducer = createReducer(
  {
    [updateFormData]: (state, formData) => ({
      ...state,
      formData: merge({}, { ...state.formData }, formData),
    }),
    [setBookingClientRequestId]: (state, bookingClientRequestId) => ({
      ...state,
      bookingClientRequestId,
    }),
    [setBookingChannel]: (state, bookingChannel) => ({
      ...state,
      bookingChannel,
    }),
    [clearFormData]: (state) => ({
      ...state,
      formData: initialState.formData,
    }),
  },
  initialState,
);
